import { z } from 'zod';

const appSchema = {
  formSchema: () => {
    return z.object({
      username: z.string().min(1, 'Username is required'),
      password: z
        .string()
        .min(8, 'Password is required and must be 8 characters long'),
    });
  },
  addReferralForm: () => {
    return z.object({
      patientId: z.number().min(1, 'Patient ID is required'),
      referralDate: z.date({ required_error: 'Referral date is required' }),
      referredBy: z.number().min(1, 'Referring provider is required'),
      urgencyLevel: z.string({ required_error: 'Urgency level is required' }),
      referredTo: z.number().min(1, 'Recipient provider is required'),
      reasonForReferral: z.string().min(1, 'Reason for referral is required'),
    });
  },
  addPatientSchema: () => {
    return z.object({
      firstName: z.string().trim().min(1, 'First name is required'),
      lastName: z.string().trim().min(1, 'Last name is required'),
      dobDate: z.any().refine((val) => val !== null && val !== '', {
        message: 'Date of birth is required',
      }),
      patDemoGender: z.string().min(1, 'Sex is required'),
      patDemoHomePhone: z
        .string()
        .min(1, 'Home phone is required')
        .regex(
          /^\(\d{3}\) \d{3}-\d{4}$/,
          'Invalid phone format (000) 000-0000',
        ),
      patDemoZip: z
        .string()
        .trim()
        .min(5, 'Zip code must be at least 5 digits')
        .max(9, 'Zip code cannot exceed 9 digits')
        .regex(/^\d+$/, 'Zip code must contain only numbers'),
      patDemoEmail: z
        .string()
        .trim()
        .email('Invalid email address')
        .optional()
        .or(z.literal('')),
    });
  },
};

export default appSchema;
